import { fetchAuthSession } from '@aws-amplify/auth';
import axios from 'axios';
import { logout } from '../store/authSlice';

const api = axios.create({
  baseURL: '/',
});

export const setAuthToken = (token: string | undefined) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
};

/**
 * Intercept the response and if it's a 401 error, try to refresh the token
 */
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401) {
      if (!originalRequest._retry) {
        // try to refresh the token
        originalRequest._retry = true;
        try {
          // console.log('error in API => forcing token refresh', error.response.status);
          const authSession = await fetchAuthSession({ forceRefresh: true });
          // console.log('New token', authSession.tokens?.idToken?.toString());
          setAuthToken(authSession.tokens?.idToken?.toString());
          originalRequest.headers.Authorization = api.defaults.headers.common.Authorization;
          return api(originalRequest); // retried the original request
        } catch (refreshError) {
          console.error('Token refresh failed :', refreshError);
          // cleanup the session
          console.error('Cleanup session ');
          await logout().finally(() => {
            window.location.href = '/';
          });
        }
      } else {
        // despite the error and successful token refresh, the request still failed in 401
        // this could be due to the token being invalid or the user not having the right permissions to call the API
        // cleanup the session too
        console.error('Still getting a 401, user config issue? Cleanup session ');
        await logout().finally(() => {
          window.location.href = '/';
        });
      }
    }
    return Promise.reject(new Error(error.message)); // For all other errors, return the error as is.
  },
);

export default api;
